function b() {
  throw new Error("error");

  return "asd";
}

function a(): string {
  return b();
}

export function DeliberatelyThrowsAnErrorPage(_props: Record<string, never>) {
  const x = a();

  return <>Error {x}</>;
}
